<template>
  <!-- 专家详情 -->
  <div class="expertDetail">
    <div class="container">
      <div class="flex" style="align-items: center;margin-bottom: 25px;padding-top: 25px;">
        <span style="font-size: 14px;">当前位置：</span>
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/resourcePool' }">资源池</el-breadcrumb-item>
          <el-breadcrumb-item>{{ name }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="detail">
        <div class="detail-left">
          <div class="detail-left-bg">
            <div class="avatar" :style="{ backgroundImage: `url(${expertInfo.avatar})` }"></div>
          </div>
        </div>
        <div class="detail-right">
          <div class="detail-right-name">
            <span class="name">{{ expertInfo.name }} / {{expertInfo.summary}}</span>
            <!-- <span v-for="(job, i) in expertInfo.expertJobList" :key="i">
              <span v-if="i < expertInfo['expertJobList'].length - 1">{{ job.title + '、' }}</span>
              <span v-else>{{ job.title }}</span>
            </span>-->
          </div>
          <div class="detail-right-profile">
            <div class="order">01</div>
            <div class="title">专家介绍</div>
          </div>
          <div class="summary" v-html="expertInfo.content">
            <!-- {{ expertInfo.summary }} -->
          </div>
          <div class="detail-right-field">
            <div class="order">02</div>
            <div class="title">研究领域</div>
          </div>
          <div class="summary">
            <span v-for="(subject, i) in expertInfo.expertSubjectList" :key="i">
              <span v-if="i < expertInfo['expertSubjectList'].length - 1">{{ subject.title + '、' }}</span>
              <span v-else>{{ subject.title }}</span>
            </span>
          </div>
        </div>
      </div>
      <div class="moreExpert" @click="back">更多专家</div>
    </div>
  </div>
</template>

<script>
import { getExpertDetail } from "../../utils/interface";
export default {
  name: "",
  components: {},
  props: {},
  metaInfo() {
    return {
      title: this.metaTitle,
      meta: [
        {
          // set meta
          name: "keywords",
          content: '数字化|专家|专家介绍|研究领域|解决方案',
        },
        {
          // set meta
          name: "description",
          content: this.metaDescription,
        },
      ],
    }
  },
  data() {
    return {
      uuid: "",
      name: "",
      expertInfo: {
        // name: '田志刚',
        // avatar: require('../../assets/publicService/resourcePool/avater.png'),
        // summary: '出生于1997年，毕业于西北工业大学', // 专家介绍
        // expertJobList: [{ title: '教授' }, { title: '博士生导师' }], // 职位
        // expertSubjectList: [{ title: '制造领域' }, { title: '大数据领域' }]
      },
      metaTitle: "",
      metaDescription: "",
    };
  },
  watch: {},
  computed: {},
  created() {
    this.uuid = this.$route.query.uuid;
    this.name = this.$route.query.name;
  },
  mounted() {
    this.getExpertDetail();
  },
  methods: {
    // 根据专家id查询专家详情
    getExpertDetail() {
      console.log(123);
      getExpertDetail(this.uuid).then(res => {
        if (res.success && Object.keys(res.data).length !== 0) {
          this.expertInfo = res.data;
          this.metaTitle = res.data.name + "-公共服务平台"
          this.metaDescription =  res.data.content.length>70?res.data.content.substring(0,70):res.data.content;
        }
      });
    },
    // 返回资源池专家
    back() {
      console.log("12331");
      //   this.$router.back()
      this.$router.push({
        path: "/resourcePool",
        query: {}
      });
    }
  }
};
</script>
<style lang="less" scoped>
.expertDetail {
  background-color: #f3f5f9;

  .container {
    width: 1300px;
    margin: 0 auto;
    background-color: transparent;
    min-height: 100%;
    overflow: hidden;
  }

  .detail {
    //height: 500px;
    display: flex;
    flex-flow: row nowrap;

    .detail-left {
      width: 500px;
      display: flex;
      justify-content: center;

      .detail-left-bg {
        width: 300px;
        height: 300px;
        background: url("../../assets/publicService/resourcePool/detailBg.png")
          no-repeat center center/100% 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;

        .avatar {
          width: 200px;
          height: 280px;
          background-size: 100% 100%;
          background-repeat: no-repeat;
        }
      }
    }

    .detail-right {
      flex: 1;

      & > div {
        margin-bottom: 30px;
      }

      .detail-right-name {
        .name {
          color: #2d50a1;
          font-size: 28px;
          font-weight: 600;
        }
      }

      .detail-right-profile {
        display: flex;
        justify-content: start;
      }

      .summary {
        width: 80%;
        min-height: 80px;
      }

      .detail-right-field {
        display: flex;
        justify-content: start;
      }

      .detail-right-field,
      .detail-right-profile {
        width: 80%;
        border-bottom: 1px solid #44556661;

        .order {
          background-color: #ac8b62;
          color: #fff;
          width: 30px;
          height: 25px;
          text-align: center;
        }

        .title {
          width: 80px;
          height: 0;
          color: #fff;
          border: 0px solid transparent;
          border-bottom: 25px solid #2d50a1;
          border-right: 25px solid transparent;
          text-align: center;
        }
      }
    }
  }

  .moreExpert {
    width: 120px;
    height: 30px;
    line-height: 30px;
    border-radius: 8px;
    color: #fff;
    font-size: 16px;
    background-color: #2d50a1;
    margin: 0 auto;
    margin-bottom: 20px;
    text-align: center;
    cursor: pointer;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/resourcePool/expertDetail.vue